import React from 'react';
import LegalPage from './LegalPage';
import LegalDocument from '../../legal/LegalDocument';
import { COOKIE } from '../../legal/documents';

const Cookie: React.FC = () => (
  <LegalPage title="Политика использования файлов cookie">
    <LegalDocument nodes={COOKIE} />
  </LegalPage>
);

export default Cookie;
